import {csstransform} from './environment.js';

const DURATION = 300;

// initializes a simple transition for `elem`
export function init(elem, duration = DURATION) {
	const transition = `${csstransform} ${duration}ms ease-in-out, opacity ${duration}ms ease-in-out`;
	elem.transitionDuration = duration;
	elem.style.transition = transition;
	elem.style['-webkit-transition'] = transition;
	const origin = '0 0';
	elem.style['transform-origin'] = origin;
	elem.style['-webkit-transform-origin'] = origin;
	elem.style.willChange = 'transform, opacity';
}

// removes the inline styles for this transition from `elem`
export function reset(elem) {
	elem.style.transition = '';
	elem.style['-webkit-transition'] = '';
	elem.style['transform-origin'] = '';
	elem.style['-webkit-transform-origin'] = '';
	elem.style.willChange = 'auto';
}

// returns a BoundingClientRect-like object for the window viewport
export function viewportBbox() {
	return {
		top: 0,
		left: 0,
		width: window.innerWidth,
		height: window.innerHeight,
	};
}

// transition elem from `viewport` to optional `target`.
// if no target is given, the transition is to the viewport
export function transition(elem, options = {}, cb = null) {
	const {viewport = viewportBbox(), target = null, scale = null} = options;
	const opacity = target || scale ? 0 : 1;
	let _transform = options.transform || 'none';
	if (target) {
		_transform = transform(viewport, target.getBoundingClientRect());
	} else if (scale) {
		_transform = transform(viewport, {
			width: viewport.width / 2,
			height: viewport.height / 2,
			top: viewport.top + viewport.height / 4,
			left: viewport.left + viewport.width / 4,
		});
	}

	end(elem, cb);

	elem.style.transform = _transform;
	elem.style['-webkit-transform'] = _transform;
	elem.style.opacity = opacity;
}

// this first transforms the element to the position defined in `from` and then
// starts a transition to `to`
export function fromTo(elem, from, to, cb) {
	transition(elem, from);
	// force layout
	if (elem.offsetWidth > 0) {
		init(elem);
	}
	setTimeout(() => transition(elem, to, () => {
		elem.style.willChange = 'auto';
		if (cb) { cb(); }
	}), 0);
}

// register a callback on the transitionend
export function end(elem, cb = null) {
	if (!cb) { return; }
	const type = 'transform' in elem.style
		? 'transitionend'
		: 'webkitTransitionEnd';
	let timeout;
	const fn = ev => {
		if (ev && ev.target !== elem) { return; }
		elem.removeEventListener(type, fn, false);
		clearTimeout(timeout);
		reset(elem);
		cb(ev);
	};
	elem.addEventListener(type, fn, false);
	timeout = setTimeout(fn, elem.transitionDuration + 100);
}

// get the transform to place `viewport` at `destination`
export function transform(viewport, destination) {
	const scale = Math.min(
		destination.width / viewport.width,
		destination.height / viewport.height);
	const top =
		destination.top + (destination.height - viewport.height * scale) / 2 - viewport.top;
	const left =
		destination.left + (destination.width - viewport.width * scale) / 2 - viewport.left;
	return `translate(${left}px, ${top}px) scale(${scale})`;
}



// WEBPACK FOOTER //
// ./lib/simpletransition.js